import { render, staticRenderFns } from "./categoriesUnitsGraphics.vue?vue&type=template&id=872705f6"
import script from "./categoriesUnitsGraphics.vue?vue&type=script&lang=js"
export * from "./categoriesUnitsGraphics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports